import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import AuthenticationFactorList
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDBox, FDContentContainer, FDPaper, FDStack,
} from '@facet-wealth/design';

const styles = (theme) => ({
  root: {
    maxWidth: theme.dimensions.lg,
    padding: theme.spacing(4),
    margin: theme.spacing(4, 0),
  },
  rootMobile: {
    margin: theme.spacing(0),
    padding: theme.spacing(4, 2),
  },
  title: {
    textAlign: 'left',
  },
});

const AuthenticationFactorsCard = ({
  classes,
}) => {
  const isMobile = useMobileLayout();

  const content = (
    <FDStack direction={'column'} spacing={4}>
      <FDStack direction={'column'} spacing={1}>
        <Title className={classes.title} text={'Security Settings'} />
        <Typography weight={'light'}>{'Setting a strong password and enabling multi-factor authentication are critical to keeping your account secure.'}</Typography>
      </FDStack>
      <AuthenticationFactorList />
    </FDStack>
  );

  if (isMobile) {
    return (
      <FDBox paddingY={2}>
        <FDContentContainer maxWidth={'xl'}>
          {content}
        </FDContentContainer>
      </FDBox>
    );
  }

  return (
    <FDBox paddingY={4}>
      <FDContentContainer maxWidth={'xl'}>
        <FDPaper padding={400} appearance={'elevated'}>
          {content}
        </FDPaper>
      </FDContentContainer>
    </FDBox>
  );
};

AuthenticationFactorsCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorsCard);
